<script setup lang="ts">
</script>
<template>
  <a
    href="https://api.whatsapp.com/send?phone=56952031798"
    rel="noopener"
    target="_blank"
    class=""
  >
    <img
      src="@/assets/icons/whatsapp.png"
      class="w-12 rounded-full shadow"
    >
  </a>
</template>
